import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
//import logo from "../../../assets/images/logo.png";
import logo from "../../../../../src/assets/images/logo.png"

const ConsentForm = () => {
  const navigate = useNavigate();
  const { formId, patientId } = useParams(); // already encoded in URL

  const [agreed, setAgreed] = useState(false);

  const handleContinue = () => {
    if (!agreed) {
      alert("Please agree to the consent terms before continuing.");
      return;
    }

    // ✅ Direct navigation for testing (no backend call)
    navigate(`/forms/patient-form/${formId}/${patientId}`);
  };

  return (
    <div className="container mt-5" style={{ maxWidth: "600px" }}>
      <div className="text-center mb-4">
        <img src={logo} alt="Logo" style={{ width: "200px", height: "auto" }} />
      </div>

      <h4 className="text-center mb-3">Consent Form</h4>
      <p>
        Please read the following consent information carefully. By checking the
        box below, you agree to allow us to use your details for the purposes of
        treatment, follow-ups, and communication. Your data will be handled
        securely and confidentially.
      </p>

      <div className="form-check my-3">
        <input
          type="checkbox"
          className="form-check-input"
          id="consentCheckbox"
          checked={agreed}
          onChange={(e) => setAgreed(e.target.checked)}
        />
        <label className="form-check-label" htmlFor="consentCheckbox">
          I have read and agree to the consent terms.
        </label>
      </div>

      <button
        className="btn btn-success w-100"
        onClick={handleContinue}
        disabled={!agreed}
      >
        Continue
      </button>
    </div>
  );
};

export default ConsentForm;
